exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".close-modal-btn[data-v-b17898c4]{position:absolute;top:20px;right:15px;cursor:pointer;font-weight:700;font-size:120%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-b17898c4&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/type/ModalCloseButton.vue
// module id = 828
// module chunks = 2